/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Meeting_Guest_Shown_Of_TotalInputs */

const vi_meeting_guest_shown_of_total = /** @type {(inputs: Meeting_Guest_Shown_Of_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang hiện ${i?.shown}/${i?.total} người. Gõ tên vào ô tìm để thu hẹp danh sách.`)
};

/**

* @param {Meeting_Guest_Shown_Of_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_shown_of_total = /** @type {((inputs: Meeting_Guest_Shown_Of_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Shown_Of_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_shown_of_total(inputs)
});